import { render, staticRenderFns } from "./addProblemFollowRecord.vue?vue&type=template&id=f8791c62&scoped=true&"
import script from "./addProblemFollowRecord.vue?vue&type=script&lang=js&"
export * from "./addProblemFollowRecord.vue?vue&type=script&lang=js&"
import style0 from "./addProblemFollowRecord.vue?vue&type=style&index=0&id=f8791c62&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8791c62",
  null
  
)

export default component.exports